module.exports = __webpack_public_path__ + "img/tool_remove.b4ed13f3.png";